import { Form, Row, Col, Badge, Button, InputGroup } from 'react-bootstrap';
import icSearch from './assets/img/ic-magnifier.svg';

const TicketFilter = ({ 
    searchQuery,
    setSearchQuery, 
    priorityFilter,
    setPriorityFilter,
    selectedOwner,
    setSelectedOwner,
    owners = [],
    ticketClassFilter,
    setTicketClassFilter,
    statusFilter,
    setStatusFilter
}) => {

    // Function to reset all filters
    const clearFilters = () => {
        setSearchQuery('');
        setPriorityFilter('');
        setSelectedOwner('');
        setTicketClassFilter('');
        setStatusFilter('');
    };

    const selectedOwnerLabel =
        owners.find(o => o.id === selectedOwner)?.label || selectedOwner;

    return (
        <>
            {/* Filter Inputs */}
            <div className="filter">
                <div>
                    <div className="flex-grow-1">
                        <Row>
                            {/* Search by Ticket Name */}
                            <Col md={2}>
                                <Form.Group controlId="searchTicket">
                                    <Form.Label>Search</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <InputGroup.Text>
                                            <img src={icSearch} alt="Search" />
                                        </InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group controlId="filterPriority">
                                    <Form.Label>Priority</Form.Label>
                                    <Form.Select
                                        value={priorityFilter}
                                        onChange={(e) => setPriorityFilter(e.target.value)}
                                    >
                                        <option value="">Priority</option>
                                        <option value="Critical">Critical</option>
                                        <option value="High">High</option>
                                        <option value="Medium">Medium</option>
                                        <option value="Low">Low</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="owner">
                                    <Form.Label>Owner</Form.Label>
                                    <Form.Select
                                        value={selectedOwner}
                                        onChange={(e) => setSelectedOwner(e.target.value)}
                                    >
                                        <option value="">Owner</option>
                                        {owners.length === 0 ? (
                                            <option value="" disabled>No owners found</option>
                                        ) : (
                                            owners.map((o) => (
                                                <option key={o.id} value={o.id}>
                                                    {o.label}
                                                </option>
                                            ))
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="filterTicketClass">
                                    <Form.Label>Class</Form.Label>
                                    <Form.Select
                                        value={ticketClassFilter}
                                        onChange={(e) => setTicketClassFilter(e.target.value)}
                                    >
                                        <option value="">Class</option>
                                        <option value="Incident">Incident</option>
                                        <option value="Support req.">Support request</option>
                                        <option value="Advisory req.">Advisory request</option>
                                        <option value="Lifecycle task">Lifecycle task</option>
                                        <option value="Special task">Special task</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group controlId="filterStatus">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                    >
                                        <option value="">Status</option>
                                        <option value="Archived">Archived</option>
                                        <option value="Open">Open</option>
                                        <option value="Resolved">Resolved</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                </div>

                {/* Applied Filters Display */}
                {(searchQuery || priorityFilter || selectedOwner || ticketClassFilter || statusFilter) && (
                    <>
                        <Row className="filter-results">
                            <Col className="d-flex align-items-center">
                                <span>Filters:</span>
                                {searchQuery && (
                                    <Badge bg="info" className="me-2">
                                        Ticket: {searchQuery} 
                                        <Button 
                                            variant="link" size="sm" className="sm"
                                            onClick={() => setSearchQuery('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}
                                

                                {priorityFilter && (
                                    <Badge bg="info" className="me-2">
                                        Priority: {priorityFilter}
                                        <Button
                                            variant="link" size="sm"
                                            onClick={() => setPriorityFilter('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}
                                {selectedOwner && (
                                    <Badge bg="info" className="me-2">
                                        Owner: {selectedOwnerLabel}
                                        <Button variant="link" size="sm" onClick={() => setSelectedOwner('')}>
                                            ×
                                        </Button>
                                    </Badge>
                                )}
                                {ticketClassFilter && (
                                    <Badge bg="info" className="me-2">
                                        Class: {ticketClassFilter}
                                        <Button 
                                            variant="link" size="sm"
                                            onClick={() => setTicketClassFilter('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}
                                
                                {statusFilter && (
                                    <Badge bg="info" className="me-2">
                                        Status: {statusFilter}
                                        <Button 
                                            variant="link" size="sm"
                                            onClick={() => setStatusFilter('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}
                                
                                {/* Clear All Filters Button */}
                                <Button variant="link" size="sm" className="ms-auto" onClick={clearFilters}>
                                    Clear All
                                </Button>
                            </Col>
                        </Row>
                    </>
                )}
            </div>
        </>
    );
};

export default TicketFilter;